const rolesColumns = {
  name: {
    key: 'name',
    label: 'name',
    type: 'text',
    sortable: false,
  },
  permissions: {
    key: 'permissions',
    label: 'permissionsCount',
    type: 'function',
    get: (value) => value && value.length,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 20,
    buttons: [
      {
        name: 'editRole',
        icon: 'fas fa-pencil',
        permissions: ['rolesManage'],
      },
      {
        name: 'showUsers',
        icon: 'fas fa-user',
      },
    ],
  },
};

export default rolesColumns;
